export enum GasFileMode {
  Single = 'single',
  Multi = 'multi'
};

export type GasFileModeType = 'multi' | 'single';
